import React, {useContext, useEffect} from "react";
import {Title} from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import {AtsAcLdgrProjects} from "../../../masters/projects/queries/types";
import {useLazyQuery} from "@apollo/client";
import {nodeVar} from "../../../../../../utils/commonQueryTypes";
import {GetProjectByNodeId} from "../../../masters/projects/queries/queries";

import {AppContext} from "../../../../../../context/context";
import {Button} from "../../../../../../stories/Button/Button";
import useFormJson from "../../../../../../json/useFormJson";
import {LabelProps} from "../../../../../../utils/types";

import Input from "../../../../../../stories/Input/Input";
import {Label} from "../../../../../../stories/Label/Label";
import {toStandardDate} from "../../../../../../utils/UtilFunctions";
import Download from "../../../../../../images/DocumentsDownload.svg";
import {getDownloadUrl} from "../../../../../../utils/DownloadFile";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  projectId: number;
}
const ViewParticularProjectDetails = ({setModalFlag, projectId}: Props) => {
  const {ProjectDetails} = useFormJson();

  const {customer_id} = useUrlParams();

  const [getProjectByNodeId, {data: projectData}] = useLazyQuery<
    {node: AtsAcLdgrProjects},
    nodeVar
  >(GetProjectByNodeId);
  useEffect(() => {
    if (projectId) {
      getProjectByNodeId({
        variables: {
          id: projectId,
        },
      });
    }
  }, [getProjectByNodeId, projectId]);

  return (
    <>
      <div className="projects-view">
        <div className="projects-add__title">
          <Title>{projectData ? projectData.node.supplierName.desc : ""}</Title>

          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>

        <div className="projects-view__form row g-0">
          <div className=" col">
            <div className="projects-view__form--h">
              <h4>Project Details</h4>
            </div>
            {ProjectDetails.left.map((field: LabelProps, key: React.Key) => {
              return (
                <div key={key} className="label-grid">
                  <Label>{field.labelName}</Label>
                  <Input
                    disabled
                    value={
                      projectData &&
                      (field.dataType === "date"
                        ? toStandardDate(
                            projectData.node[
                              field.inputName as keyof AtsAcLdgrProjects
                            ] as string
                          )
                        : projectData.node[
                            field.inputName as keyof AtsAcLdgrProjects
                          ])
                    }
                  />
                </div>
              );
            })}
          </div>
          <div className=" col">
            <div className="projects-view__form--h">
              <h4>Other Details</h4>
            </div>
            {ProjectDetails.right.map((field: LabelProps, key: React.Key) => {
              return (
                <div className="label-grid" key={key}>
                  <Label>{field.labelName}</Label>
                  <div className="projects-view__form--flex">
                    <Input
                      disabled
                      value={
                        projectData &&
                        (field.dataType === "date"
                          ? toStandardDate(
                              projectData.node[
                                field.inputName as keyof AtsAcLdgrProjects
                              ] as string
                            )
                          : projectData.node[
                              field.inputName as keyof AtsAcLdgrProjects
                            ])
                      }
                    />
                    {(field.inputName === "agreementFile" ||
                      field.inputName === "endAgreementFile") &&
                      projectData &&
                      projectData.node[field.inputName] && (
                        <img
                          src={Download}
                          alt="Download"
                          onClick={() => {
                            const ext =
                              projectData &&
                              (
                                projectData.node[
                                  field.inputName as keyof AtsAcLdgrProjects
                                ] as string
                              )
                                .split(".")
                                .pop();
                            getDownloadUrl(
                              `${customer_id}/vendor/${projectData.node.ldgrID}/projects/${projectData.node.id}/${field.inputName}.${ext}`,
                              true
                            );
                          }}
                        />
                      )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <Button
          mode={"cancel"}
          type="button"
          onClick={() => {
            setModalFlag(false);
          }}
        />
      </div>
    </>
  );
};

export default ViewParticularProjectDetails;
